import { MyleTableColumnOptions } from "@/Common/Components/Tables/MyleTableColumn";
import { PortfolioPortalSyncHistoryOrderType } from "@/Common/Models/UI/Enums";
import { PortalSyncBaseComponent } from "./PortalSync/PortalSyncBaseComponent";
import { PortfolioSaveOptionKey } from "./PortfolioSaveOptionKey";

class PortalPendingItems extends PortalSyncBaseComponent {
    protected getSaveOptionKey(): string {
        return PortfolioSaveOptionKey.PortalPendingItems;
    }

    protected showStatusFilters(): boolean {
        return false;
    }

    protected getMyleTableColumnsOptions(): MyleTableColumnOptions[] {
        return [
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("PatientLabel"),
                FieldName: "PatientName",
                WidthPercentageDefault: 20
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("PhoneLabel"),
                FieldName: "PatientPhoneNumbers",
                WidthPercentageDefault: 20,
                RowClickEnabled: true
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("ItemLabel"),
                FieldName: "SyncItemName",
                WidthPercentageDefault: 20,
                RowClickEnabled: true
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("DateLabel"),
                FieldName: "SyncDate",
                WidthPercentageDefault: 16,
                RowClickEnabled: true,
                IsSortable: true,
                SortColumn: PortfolioPortalSyncHistoryOrderType.SyncDate,
                SortDirection: this.props.model?.get("Settings")?.get("OrderByDirection"),
                IsSortActive: this.props.model?.get("Settings")?.get("OrderByColumn") === PortfolioPortalSyncHistoryOrderType.SyncDate
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("UserLabel"),
                FieldName: "SyncUser",
                WidthPercentageDefault: 16,
                RowClickEnabled: true
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("PortalLabel"),
                FieldName: "PortalStatus",
                WidthPercentageDefault: 8,
                RowClickEnabled: true
            })
        ];
    }
}

export { PortalPendingItems };
